import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, MANTINE_SIZES } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var getColumnFlexBasis = function getColumnFlexBasis(colSpan, columns) {
  if (colSpan === "content") {
    return "auto";
  }
  if (colSpan === "auto") {
    return "0px";
  }
  return colSpan ? "".concat(100 / (columns / colSpan), "%") : void 0;
};
var getColumnMaxWidth = function getColumnMaxWidth(colSpan, columns, grow) {
  if (grow || colSpan === "auto" || colSpan === "content") {
    return "unset";
  }
  return getColumnFlexBasis(colSpan, columns);
};
var getColumnFlexGrow = function getColumnFlexGrow(colSpan, grow) {
  if (!colSpan) {
    return void 0;
  }
  return colSpan === "auto" || grow ? 1 : 0;
};
var getColumnOffset = function getColumnOffset(offset, columns) {
  return offset === 0 ? 0 : offset ? "".concat(100 / (columns / offset), "%") : void 0;
};
var getGutterSize = function getGutterSize(gutter, theme) {
  return typeof gutter !== "undefined" ? theme.fn.size({
    size: gutter,
    sizes: theme.spacing
  }) / 2 : void 0;
};
function getBreakpointsStyles(_ref) {
  var sizes = _ref.sizes,
    offsets = _ref.offsets,
    orders = _ref.orders,
    theme = _ref.theme,
    columns = _ref.columns,
    gutters = _ref.gutters,
    grow = _ref.grow;
  return MANTINE_SIZES.reduce(function (acc, size) {
    acc["@media (min-width: ".concat(theme.breakpoints[size], "px)")] = {
      order: orders[size],
      flexBasis: getColumnFlexBasis(sizes[size], columns),
      padding: getGutterSize(gutters[size], theme),
      flexShrink: 0,
      width: sizes[size] === "content" ? "auto" : void 0,
      maxWidth: getColumnMaxWidth(sizes[size], columns, grow),
      marginLeft: getColumnOffset(offsets[size], columns),
      flexGrow: getColumnFlexGrow(sizes[size], grow)
    };
    return acc;
  }, {});
}
var useStyles = createStyles(function (theme, _ref2) {
  var gutter = _ref2.gutter,
    gutterXs = _ref2.gutterXs,
    gutterSm = _ref2.gutterSm,
    gutterMd = _ref2.gutterMd,
    gutterLg = _ref2.gutterLg,
    gutterXl = _ref2.gutterXl,
    grow = _ref2.grow,
    offset = _ref2.offset,
    offsetXs = _ref2.offsetXs,
    offsetSm = _ref2.offsetSm,
    offsetMd = _ref2.offsetMd,
    offsetLg = _ref2.offsetLg,
    offsetXl = _ref2.offsetXl,
    columns = _ref2.columns,
    span = _ref2.span,
    xs = _ref2.xs,
    sm = _ref2.sm,
    md = _ref2.md,
    lg = _ref2.lg,
    xl = _ref2.xl,
    order = _ref2.order,
    orderXs = _ref2.orderXs,
    orderSm = _ref2.orderSm,
    orderMd = _ref2.orderMd,
    orderLg = _ref2.orderLg,
    orderXl = _ref2.orderXl;
  return {
    col: __spreadValues({
      boxSizing: "border-box",
      flexGrow: getColumnFlexGrow(span, grow),
      order: order,
      padding: getGutterSize(gutter, theme),
      marginLeft: getColumnOffset(offset, columns),
      flexBasis: getColumnFlexBasis(span, columns),
      flexShrink: 0,
      width: span === "content" ? "auto" : void 0,
      maxWidth: getColumnMaxWidth(span, columns, grow)
    }, getBreakpointsStyles({
      sizes: {
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl
      },
      offsets: {
        xs: offsetXs,
        sm: offsetSm,
        md: offsetMd,
        lg: offsetLg,
        xl: offsetXl
      },
      orders: {
        xs: orderXs,
        sm: orderSm,
        md: orderMd,
        lg: orderLg,
        xl: orderXl
      },
      gutters: {
        xs: gutterXs,
        sm: gutterSm,
        md: gutterMd,
        lg: gutterLg,
        xl: gutterXl
      },
      theme: theme,
      columns: columns,
      grow: grow
    }))
  };
});
export default useStyles;